module.exports = __webpack_public_path__ + "static/media/mollo_2_filter.57d7a01c.png";